import React, { ComponentProps } from 'react';
import { FormResultProvider } from 'src/hooks/useFormResultController';
import StatsigProviderMask from 'atoms/AbTesting/AbTestingProvider';
import { FreeTrialFormProvider } from './useFreeTrialFormContext';
import { PathToProOfferOverrideProvider } from './usePathToProOfferOverride';
import { HeaderDesignControllerProvider } from './useHeaderDesignController';
import { PopupControllerProvider } from './usePopupController';

const PROVIDERS = [
  FormResultProvider,
  StatsigProviderMask,
  PathToProOfferOverrideProvider,
  HeaderDesignControllerProvider,
  PopupControllerProvider,
  FreeTrialFormProvider,
];

const combineProviders = (): React.FC<any> => {
  return PROVIDERS.reduce(
    (AccComponent, Provider) => {
      const AggregatedComponents = ({ children }: ComponentProps<React.FC<any>>): JSX.Element => (
        <AccComponent>
          <Provider>{children}</Provider>
        </AccComponent>
      );

      return AggregatedComponents;
    },
    ({ children }: { children: React.ReactNode }) => <>{children}</>
  );
};

const ContextProviders = combineProviders();

export default ContextProviders;
